/**
 * Composable pour gérer l'auto-remplissage de l'identifiant de structure
 * Pattern: 1 + Licence + 0000
 * Appliqué à toute licence sélectionnée (démo et non-démo)
 */

export function useStructureIdentifier() {
  const normalizeLicenceId = (licenceId) => {
    if (licenceId == null || licenceId === "") {
      return "";
    }
    const normalized = String(Number(licenceId));
    return normalized === "NaN" ? String(licenceId) : normalized;
  };

  /**
   * Génère l'identifiant de structure basé sur le pattern
   * Pattern: 1 + licenceId + 0000
   * @param {string|number} licenceId - L'identifiant de la licence MS4
   * @returns {string} - L'identifiant généré
   */
  const generateStructureIdentifier = (licenceId) => {
    const normalized = normalizeLicenceId(licenceId);
    if (!normalized) {
      return "";
    }
    return `1${normalized}0000`;
  };

  /**
   * Détermine si une licence est en mode démo
   * @param {Object} cabinet - L'objet cabinet/licence avec les propriétés
   * @returns {boolean} - true si la licence est en mode démo (a=1)
   */
  const isLicenceDemo = (cabinet) => {
    const licenceId = normalizeLicenceId(
      cabinet?.licenceID || cabinet?.ms4LicenceId
    );
    if (licenceId && cabinet?.licences?.length) {
      const specificLicence = cabinet.licences.find(
        (l) => normalizeLicenceId(l.licenceID) === licenceId
      );
      if (specificLicence) {
        return specificLicence.demo === 1 || specificLicence.demo === true;
      }
    }
    return cabinet?.demo === 1 || cabinet?.demo === true;
  };

  /**
   * Traite le changement de licence sélectionnée.
   * Remplit toujours l'identifiant structure (démo et non-démo).
   * @param {Object} selectedCabinet - Le cabinet/licence sélectionné
   * @param {Object} structure - L'objet structure à mettre à jour
   * @returns {Object} - Les modifications à appliquer
   */
  const handleLicenceChange = (selectedCabinet, structure) => {
    const licenceId = normalizeLicenceId(
      selectedCabinet?.licenceID ||
        selectedCabinet?.ms4LicenceId ||
        selectedCabinet?.licence
    );
    const isDemo = isLicenceDemo(selectedCabinet);

    return {
      ...structure,
      finessNumber: generateStructureIdentifier(licenceId),
      isDemo,
      isDemoMode: true,
    };
  };

  return {
    normalizeLicenceId,
    generateStructureIdentifier,
    isLicenceDemo,
    handleLicenceChange,
  };
}
